import { render, staticRenderFns } from "./FarmGroupForm.vue?vue&type=template&id=1cd9f2f0&"
import script from "./FarmGroupForm.vue?vue&type=script&lang=ts&"
export * from "./FarmGroupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports